import { forwardRef } from 'react'

import { tv, type VariantProps } from 'tailwind-variants'

export const flexVariants = tv({
  base: 'flex',
  variants: {
    direction: {
      row: 'flex-row',
      col: 'flex-col'
    },
    align: {
      start: 'items-start',
      center: 'items-center',
      end: 'items-end',
      stretch: 'items-stretch'
    },
    justify: {
      start: 'justify-start',
      center: 'justify-center',
      end: 'justify-end',
      between: 'justify-between',
      around: 'justify-around',
      evenly: 'justify-evenly'
    },
    wrap: {
      nowrap: 'flex-nowrap',
      wrap: 'flex-wrap',
      reverse: 'flex-wrap-reverse'
    },
    gap: {
      0: 'gap-0',
      1: 'gap-1',
      2: 'gap-2',
      4: 'gap-4',
      6: 'gap-6',
      8: 'gap-8'
    }
  },
  defaultVariants: {
    direction: 'row',
    align: 'start',
    justify: 'start',
    wrap: 'nowrap',
    gap: 0
  }
})

export type TFlexProps = React.HTMLAttributes<HTMLDivElement> &
  VariantProps<typeof flexVariants>

/**
 * @deprecated acqua does not ship layout primitives by design — use Tailwind flex utility classes directly.
 */
export const Flex = forwardRef<HTMLDivElement, TFlexProps>(
  ({ className, direction, align, justify, wrap, gap, ...props }, ref) => (
    <div
      ref={ref}
      className={flexVariants({
        direction,
        align,
        justify,
        wrap,
        gap,
        className
      })}
      {...props}
    />
  )
)

Flex.displayName = 'Flex'
